import { Checkbox } from 'antd'
import { FC } from 'react'
import { useUpdatePrintQueueEntryMutation } from '../../../../../store/api/print-queue-entries-api'
import PrintQueueEntry from '../../../../../types/api/print-queue-entry'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import { BusinessRole } from '../../../../../types/api/user'
import { useAppSelector } from '../../../../../store/store'

interface PreparedCheckboxProps {
    record: PrintQueueEntry
    field: 'stampPrepared' | 'formsPrepared' | 'blankPrepared'
}

const PreparedCheckbox: FC<PreparedCheckboxProps> = ({ record, field }) => {
    const [updateEntry, updateEntryState] = useUpdatePrintQueueEntryMutation()
    useErrorModal(updateEntryState, 'Не удалось обновить параметр')

    const user = useAppSelector(state => state.auth.user)
    const isColorist = user?.businessRoles?.includes(BusinessRole.Colorist)

    const disabled = isColorist

    return (
        <Checkbox
            checked={!!record[field]}
            disabled={disabled}
            onChange={e =>
                updateEntry({
                    docId: record.documentId,
                    body: { data: { [field]: e.target.checked } },
                })
            }
        />
    )
}

export default PreparedCheckbox
